import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {APP} from "../../app/consts";
import {GoogleAnalyticsEventModel} from "../../../third-party-services/analytics/google-analytics/google-analytics-event-model";
import {LanguageViewModel} from "../../../domain/locale/models/language/language.view-model";

export class LangSelectionClickEvent extends ClickEvent {
  source: APP.ANALYTICS.SOURCES;
  sourceLang: LanguageViewModel;
  targetLang: LanguageViewModel;

  constructor(source: APP.ANALYTICS.SOURCES, sourceLang, targetLang) {
    super('', 'click', 'lang-selection');

    this.source = source;
    this.sourceLang = sourceLang;
    this.targetLang = targetLang;
  }

  get properties() {
    const properties = super.properties;

    properties.source = this.source;
    properties.sourceLangId = this.sourceLang.id;
    properties.targetLangId = this.targetLang.id;

    return properties;
  }

  get googleAnalyticsEvent(): null {
    const eventName = this.resolveEventName();
    return new GoogleAnalyticsEventModel(eventName, {
      from: this.sourceLang.displayName,
      to: this.targetLang.displayName,
      url: window.location.href
    })
  }
}
